<template>
  <div>
    <PageTitle :title="$t('global.plans')">
      <template #actions>
        <router-link :to="{ name: 'checkout' }" class="button-router-link">
          <Btn variant="primary">{{ $t("global.create-plan") }}</Btn>
        </router-link>
      </template>
    </PageTitle>
    <div class="pending-plans">
      <div v-if="ordersStatus.isLoading">
        <Alert variant="info" :dismissible="false">
          <span class="d-flex">
            <Icon icon="loader" color="alpha" />
            <span class="ml-2">Checking for pending plans</span>
          </span>
        </Alert>
      </div>
      <div v-else-if="ordersStatus.isLoaded && orders.length">
        <div class="pending-plan" v-for="order in orders" :key="order.id">
          <Alert variant="info" :dismissible="false">
            <span class="d-flex">
              <Icon icon="loader" color="alpha" />
              <span class="ml-2">
                We’re working on your plan! ({{ order.identity }}
                <span v-if="order.location" class="ml-1">
                  -&nbsp;Location: {{ order.location.location }}
                </span>
                )
              </span>
            </span>
          </Alert>
        </div>
      </div>
    </div>
    <PlansTable :plans="plans" />
  </div>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import Alert from "@/components/display/Alert";
import Btn from "@/components/display/Btn";
import Icon from "@/components/display/icon/Icon";
import PageTitle from "@/components/display/PageTitle";
import PlansTable from "@/components/smart/tables/PlansTable";
import store from "@/store";

export default {
  name: "PlansList",
  components: {
    Alert,
    Btn,
    Icon,
    PlansTable,
    PageTitle,
  },
  setup() {
    const plans = computed(() => store.state.plans);
    const ordersStatus = computed(() => store.state.orders.status);
    const orders = computed(() =>
      store.state.orders.list.filter(
        (order) =>
          order.status === "pending" && order.serviceId === 0 && order.type === "virt-guest-cloud"
      )
    );

    onMounted(() => {
      store.dispatch("plans/getList");
      store.dispatch("orders/getList");
    });

    return {
      plans,
      orders,
      ordersStatus,
    };
  },
};
</script>
